import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
    data:{}
   
    
}
const mutations={


    getProductGroupIndex(){
        
        
     
        post(urls.admin.product_group.index,{}).then((result)=>{

          state.data=result
         

          
       
        
       
           
        });
        
    },
    addProductGroupData(state,value){
        
        
     
        post(urls.admin.product_group.add,value).then((result)=>{
         
         
          state.data=result
         
          
          
       
        
       
           
        });
        
    },
    editProductGroupData(state,value){



        post(urls.admin.product_group.edit,value).then((result)=>{


            state.data=result







        });

    },
    deleteProductGroupData(state,value){



        post(urls.admin.product_group.delete,value).then((result)=>{


            state.data=result







        });

    },
    stateProductGroupData(state,value){



        post(urls.admin.product_group.state,value).then((result)=>{


            state.data=result







        });

    },


}
const  actions={
    getProductGroupIndexAction(context,value){
       
        context.commit("getProductGroupIndex",value)
       
    },
    addProductGroupDataAction(context,value){
       
        context.commit("addProductGroupData",value)
       
    },
    editProductGroupDataAction(context,value){

        context.commit("editProductGroupData",value)

    },
    deleteProductGroupDataAction(context,value){

        context.commit("deleteProductGroupData",value)

    },
    stateProductGroupDataAction(context,value){

        context.commit("stateProductGroupData",value)

    },

  
    
   

}

export default {state,mutations,actions}